module.exports = __webpack_public_path__ + "static/media/festivalforet.c4f18e9f.jpg";